<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-space-y-10 tw-justify-center tw-my-8 tw-w-full tw-max-w-sm tw-mx-auto">
    <svg-vue
      icon="icons/loading"
      class="tw-w-1/2 tw-h-auto tw-text-primary-200"
    />
    <p class="tw-text-2xl tw-text-center">
      <slot>Loading</slot>
    </p>
  </div>
</template>
